// extracted by mini-css-extract-plugin
module.exports = {"infoList":"infoList___3c56i"};